var ProductTypes = {
  Root: "Root",
  Group: "Group",
  Variant: "Variant"
};

export default ProductTypes;
